import { render } from "./getInfo.vue?vue&type=template&id=0407d8c8"
import script from "./getInfo.vue?vue&type=script&lang=js"
export * from "./getInfo.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/staging-package-front-survey/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__